var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import DataAccess from "../../DataAccess";
export var Ptn;
(function (Ptn) {
    var _a;
    class ResultTableRow {
        static checkCache() {
            const v = localStorage.getItem('ptn-version');
            if (v !== this.version) {
                localStorage.clear();
                localStorage.setItem('ptn-version', this.version);
            }
        }
        static tryGetTrialResults(trialId, categoryId, includeArchived) {
            return __awaiter(this, void 0, void 0, function* () {
                let url = `TrialResults/trialresults?trialId=${trialId}` +
                    (categoryId ? `&categoryId=${categoryId}` : "");
                if (includeArchived) {
                    url += `&includeArchived=${includeArchived}`;
                }
                return yield DataAccess.getData(url);
            });
        }
        // process the return result and return an array of ResultCategoryModel from the response.data
        static GetTrialResults(trialId, categoryId, includeArchived) {
            return __awaiter(this, void 0, void 0, function* () {
                const cachedData = yield this.getCachedTrialResults(trialId, categoryId !== null && categoryId !== void 0 ? categoryId : "", includeArchived !== null && includeArchived !== void 0 ? includeArchived : false);
                if (cachedData.length > 0) {
                    //console.log("Using cached data for trial results", cachedData);
                    return cachedData;
                }
                console.log("No cached data found for trial results");
                const response = yield this.tryGetTrialResults(trialId, categoryId, includeArchived);
                if (response && response.status === 200 && response.data) {
                    //console.log("Getting data for trial results", response.data);
                    let resultTableRows = response.data.map((item) => {
                        return Object.assign(Object.assign({}, item), { columnLsd: typeof item.columnLsd === 'string'
                                ? item.columnLsd.split(",").map(Number)
                                : [] });
                    });
                    // Don't cache when includeArchived=true — the dataset is large (admin view) and can exceed localStorage quota
                    if (!includeArchived) {
                        yield this.setCachedTrialResults(trialId, categoryId !== null && categoryId !== void 0 ? categoryId : "", resultTableRows);
                        console.log("Setting cached data for trial results", resultTableRows);
                    }
                    return resultTableRows;
                }
                return [];
            });
        }
        // Update trialResult
        //update method to archive trial result id, and isArchived only required
        static UpdateTrialResult(trialResultId, isArchived, valueLevelUpdate) {
            return __awaiter(this, void 0, void 0, function* () {
                const url = `TrialResults/update`;
                const model = {
                    id: trialResultId,
                    isArchived: isArchived !== null && isArchived !== void 0 ? isArchived : false,
                    valueLevelUpdate: valueLevelUpdate !== null && valueLevelUpdate !== void 0 ? valueLevelUpdate : false,
                };
                //console.log("Attempting to update trial result", model);
                return yield DataAccess.updateData(url, model);
            });
        }
    }
    _a = ResultTableRow;
    ResultTableRow.version = '3.0.13';
    //================================================================================================
    //        SETTING THE CACHED TRIAL RESULTS IN LOCAL STORAGE
    //        Storage key for data is TrialID-CategoryID
    //        Storage key for time is TrialID-CategoryID-YYYY-MM-DD-HH-MM-SS
    //================================================================================================
    ResultTableRow.setCachedTrialResults = (trialId, categoryId, data) => __awaiter(_a, void 0, void 0, function* () {
        const storageKey = `${trialId}-${categoryId}`;
        const storageTimeKey = `${trialId}-${categoryId}-time`;
        const currentTime = new Date().toISOString();
        try {
            localStorage.setItem(storageKey, JSON.stringify(data));
            localStorage.setItem(storageTimeKey, currentTime);
        }
        catch (e) {
            // localStorage quota exceeded — skip caching, data will be fetched fresh next time
            console.warn("localStorage quota exceeded, skipping trial results cache.", e);
            localStorage.removeItem(storageKey);
            localStorage.removeItem(storageTimeKey);
        }
    });
    //================================================================================================
    //        CACHING OF TRIAL RESULTS IN LOCAL STORAGE FOR MAXIMUM OF 5 MINUTES
    //        Storage key for data is TrialID-CategoryID
    //        Storage key for time is TrialID-CategoryID-YYYY-MM-DD-HH-MM-SS
    //        If the time is greater than 5 minutes, the data is removed from the local storage
    //        And the function returns no data otherwise it returns the data from the local storage
    //        and converts it to ResultTableRowModel[]
    //================================================================================================
    ResultTableRow.getCachedTrialResults = (trialId, categoryId, includeArchived) => __awaiter(_a, void 0, void 0, function* () {
        _a.checkCache();
        const storageKey = `${trialId}-${categoryId}`;
        const storageTimeKey = `${trialId}-${categoryId}-time`;
        const currentTime = new Date();
        const cachedTime = localStorage.getItem(storageTimeKey);
        const cachedData = localStorage.getItem(storageKey);
        const expiryTimeMinutes = 1;
        if (cachedTime && cachedData) {
            const cacheExpiresDateTime = new Date(cachedTime);
            cacheExpiresDateTime.setMinutes(cacheExpiresDateTime.getMinutes() + expiryTimeMinutes);
            if (currentTime > cacheExpiresDateTime) {
                localStorage.removeItem(storageKey);
                localStorage.removeItem(storageTimeKey);
                return [];
            }
            else {
                // Update the expiry time in local storage (sliding cache)
                localStorage.setItem(storageTimeKey, currentTime.toISOString());
            }
            return JSON.parse(cachedData);
        }
        return [];
    });
    Ptn.ResultTableRow = ResultTableRow;
})(Ptn || (Ptn = {}));
